export default __webpack_public_path__ + "media/storefront/features/hymns/hymns/Australia-94f24f4e5a6c6ec997baa6e341f3d892.mp3";